<template>
  <resolver
    :key="compKey"
    :resolvers="resolvers"
    :route-name="routeName"
  >
    <template v-slot="{ resolverProps }">
      <router-view
        v-slot="{ Component }"
        v-bind="propsAndAttrs"
      >
        <component
          :is="Component"
          :resolve-result="resolverProps"
        >
          <template
            v-for="name in $slots"
            v-slot:[String(name)]="data"
          >
            <slot
              :name="name"
              v-bind="data"
            />
          </template>
        </component>
      </router-view>
    </template>

    <template v-slot:failed="{ onRetry }">
      <tm-error-state
        size="medium"
        @on-retry="onRetry"
      />
    </template>

    <template v-slot:preloader>
      <compose-message-preload />
    </template>
  </resolver>
</template>

<script lang="ts">
import Resolver from '@/components/resolvers/Resolver.vue'
import { computed, defineComponent, toRef } from '@/composition/vue/compositionApi'
import TmErrorState from '@/components/shared/TmErrorState.vue'
import { resolversBaseProps, useResolver } from '@/composition/resolvers'
import ComposeMessagePreload from '@/components/preloaders/ComposeMessagePreload.vue'

export default defineComponent({
  components: {
    ComposeMessagePreload,
    TmErrorState,
    Resolver,
  },
  inheritAttrs: false,
  props: {
    ...resolversBaseProps,
  },
  setup(props, context) {
    const propsAndAttrs = computed(() => {
      const { routeName, resolvers, ...otherProps } = props

      return { ...context.attrs, ...otherProps }
    })

    const { compKey } = useResolver(toRef(props, 'routeName'))

    return {
      compKey,
      propsAndAttrs,
    }
  },
})
</script>
